import currencyFormatter from 'currency-formatter';
import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { compose, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { dateFormats, intervals } from '../../../../../constants';
import { userActions } from '../../../../../state/modules/user';
import { InputFormField, NumberFormField } from '../../../../components';
import { followedBy, nested } from '../../../../components/higher-order';
import { Equation } from './plan-details';

const PlanUpgradeDetail = ({
  upgradePlan,
  businessName,
  businessSize,
  onChange,
  validation,
  planId,
  individualPlanId,
  smallTeamPlanId,
  interval,
  unitPrice,
  totalPrice,
  isUpgrading,
  endDate
}) => ([
  <h2 key="heading-1">
    Upgrade to business plan
  </h2>,
  <hr key="interval-1" />,
  <h2 key="heading-2">
    Business name
  </h2>,
  <Row key="business-name">
    <Col xs={12}>
      <InputFormField
        id='business-name'
        required
        validation={validation.businessName ? null : 'Business name is required.'}
        value={businessName}
        onChange={(e) => onChange(e.target.value, 'businessName')} />
    </Col>
  </Row>,
  <h2 key="heading-3" className="thick-margin-top">
    Team members on your plan
    </h2>,
  <Row key="business-size">
    <Col xs={12}>
      <NumberFormField
        id='businessSize'
        label={null}
        validation={validation.businessSize ? null : "Business size must be larger than 1"}
        value={businessSize}
        onChange={(e) => onChange(e.value, 'businessSize')}
        required
        min={0}
        formFieldProps={{ formItemProps: { className: 'clear-fix' } }} />
    </Col>
  </Row>,
  <h2 key='interval'>
    {fp.flow(fp.get(interval), fp.upperFirst)(intervals)} payment amount
  </h2>,
  <Equation
    {...{
      key: 'equation',
      individualPlanId,
      planId,
      numberOfUsers: businessSize,
      smallTeamPlanId,
      unitPrice
    }} />,
  <p key='total' className='total'>
    <i>$</i>
    <span className='total'>
      {totalPrice}
    </span>
    &nbsp;
    <span className='note'>
      per {interval} direct debit, ex GST
      <br />
      payment from credit card
    </span>
  </p>,
  <h2 key='next-payment-heading'>
    Next payment date
  </h2>,
  <p key='next-payment-date' className='nextPaymentDate'>
    {dateFnsCompat.format(endDate, dateFormats.LongDate)}
  </p>
])

const mapStateToProps = ({
  user
}) => ({
  email: user.currentUser.email,
  endDate: user.currentSubscription.endDate
})

const mapDispatchToProps = (dispatch) => ({
  upgradeUserSubscription: bindActionCreators(userActions.user.upgradeSubscription, dispatch)
})

const validate = {
  businessName: (name) => name && name.length > 0,
  businessSize: (size) => size && size > 1
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({
    plans,
    planId
  }) => ({
    plan: fp.find(({ id }) => id === planId)(plans)
  })),
  withStateHandlers(
    () => ({
      businessName: '',
      businessSize: 2,
      validation: {
        businessName: true,
        businessSize: true
      },
      isUpgrading: false
    }),
    {
      onChange: ({
        validation
      }) => (value, fieldName) => ({
        [fieldName]: value,
        validation: {
          ...validation,
          [fieldName]: validate[fieldName](value)
        }
      }),
      onValidate: () => (validation) => ({
        validation
      }),
      setUpgrading: () => () => ({
        isUpgrading: true
      })
    }
  ),
  withProps(({
    plan: {
      interval: {
        interval
      },
      unitPrice: {
        currencyCode: code,
        minorAmount
      }
    },
    businessSize
  }) => ({
    interval,
    unitPrice: currencyFormatter.format(minorAmount / 100, { code }),
    totalPrice: currencyFormatter.format(minorAmount * parseInt(businessSize, 10) / 100, { format: '%v' }),
  })),
  withProps(
    ({
      businessName,
      businessSize
    }) => ({
      getValidation: () => ({
        businessName: validate["businessName"](businessName),
        businessSize: validate["businessSize"](businessSize)
      })
    })
  ),
  withHandlers({
    upgradePlan: ({
      planId,
      getValidation,
      onValidate,
      upgradeUserSubscription,
      businessName,
      businessSize,
      email,
      smallTeamPlanId,
      setUpgrading
    }) => () => {
      const validation = getValidation()
      const valid = fp.flow(
        fp.values,
        fp.all(fp.identity)
      )(validation)
      if (valid) {
        upgradeUserSubscription(businessName, businessSize, email, smallTeamPlanId)
        setUpgrading()
      } else {
        onValidate(validation)
      }
    }
  }),
  nested([
    ({ children }) => (
      <div className='business-subscription clearfix'>
        {children}
      </div>
    )
  ]),
  nested([
    ({
      children,
    }) => (
        <form
          noValidate>
          {children}
        </form>
      )
  ]),
  followedBy(0, ({
    isUpgrading,
    upgradePlan
  }) => [
      <p key="submit" className='text-center'>
        <Button onClick={upgradePlan}>
          {
            isUpgrading ?
              <Spinner name='circle' className='spinner' fadeIn='none' /> :
              'confirm upgrade'
          }
        </Button>
      </p>
    ])
)(PlanUpgradeDetail)



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/components/plan-upgrade-detail.js